import React, { useEffect, useState } from 'react';
import { Collapse, CollapseProps, Table } from 'antd';
import { NameOf } from 'src/utils';
import { ColumnProps } from 'antd/lib/table';
import TableColumnBuilder from 'src/utils/core/TableColumnBuilder';
import { FilterValue } from 'antd/lib/table/interface';
import ContractListItemDTO from 'src/models/generated/ContractListItemDTO';

export interface ContractsTableProps {
  data?: ContractListItemDTO[];
  loading?: boolean;
}

const ContractsTable: React.FC<ContractsTableProps> = (props) => {
  const [filteredInfo, setFilteredInfo] = useState<Record<string, FilterValue | null>>({});
  const [openKeys, setOpenKeys] = useState<Parameters<Required<CollapseProps>['onChange']>[0]>(['1']);
  const tableData = props.data ?? [];

  useEffect(() => {
    if (props.loading) {
      setFilteredInfo({});
    }
  }, [props.data]);

  const tableColumns: ColumnProps<ContractListItemDTO>[] = [
    TableColumnBuilder.Create<ContractListItemDTO>('pos', 'POS')
      .Width(100)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<ContractListItemDTO>('code', 'Code')
      .Width(100)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<ContractListItemDTO>('type', 'Type')
      .Width(150)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<ContractListItemDTO>('asset', 'Asset')
      // .Width(400)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<ContractListItemDTO>('product', 'Product')
      .Width(180)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<ContractListItemDTO>('startDate', 'Start Date')
      .Width(180)
      .AddSorter('Date')
      .AddEnumFilterer(tableData.map(x => x.startDate).filter(x => x != null && x?.year() > 2000).map(x => x?.format('L') ?? ''), 'Date')
      .AddRenderer('ShortDate')
      .DefaultSortOrder('descend')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<ContractListItemDTO>('endDate', 'End Date')
      .Width(180)
      .AddSorter('Date')
      .AddEnumFilterer(tableData.map(x => x.endDate).filter(x => x != null && x?.year() > 2000).map(x => x?.format('L') ?? ''), 'Date')
      .AddRenderer('ShortDate')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<ContractListItemDTO>('plan', 'Plan')
      .Width(100)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
  ];

  return <div className='contract-table table-section'>
    <Collapse ghost collapsible='header' activeKey={openKeys} onChange={setOpenKeys}>
      <Collapse.Panel key={1} header={<h3 className='table-title'>Contracts</h3>}>
        <Table
          rowKey={NameOf<ContractListItemDTO>('id')}
          className='condensed-table striped-table borderless-table'
          rowClassName={(record, index) => (index % 2 ? 'striped-row' : '')}
          loading={props.loading}
          pagination={false}
          columns={tableColumns}
          dataSource={tableData}
          onChange={(_, filters) => { setFilteredInfo(filters); }}
        />
      </Collapse.Panel>
    </Collapse>
  </div>;
};

export default ContractsTable;
